var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.tab + "View", {
    tag: "component",
    attrs: {
      tabSelected: _vm.tab,
      defaultDate: _vm.date,
      defaultSelectedPost: _vm.defaultSelectedPost
    },
    on: { changeTab: _vm.changeTab }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }